import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

//Pages
import LoginSignUp from './pages/login-signup/login-signup.component';
import Register from './pages/register/register';
import VerifyEmail from './pages/verify-email/verify-email';
import ForgotPassword from './pages/forgot-password/forgot-password.component';
import Dashboard from './pages/dashboard/dashboard.component';
import MyProfile from './pages/my-profile/my-profile.component';
import Schedule from './pages/schedule/schedule.component';
import ChangePassword from './pages/change-password/change-password.component';
import Connections from './pages/connections/connections.component';
import MyConnections from './pages/connections/my-connections.component';
import MyPendingConnections from './pages/connections/pending-connections.component';
import FAQ from './pages/faq/faq.component';
import Feedback from './pages/feedback/feedback.component';
import Support from './pages/support/support.components';
import ManagePreferences from './pages/manage-preferences/manage-preferences.component';
import NoMatch from './pages/404/404.component';
import MyConnection from './pages/my-connection/my-connection.components';
import CallScheduled from './pages/call-schedule/call-schedule.components';
import AfterCallConnect from './pages/after-call-connect/after-call-connect.components';
import TermsAndConditions from './pages/terms-and-conditions/terms-and-conditions.components';
import RescheduleCall from './pages/reschedule/RescheduleCall.component';
import Unsubscribe from './pages/unsubscribe/unsubscribe.component';
import Settings from './pages/schedule/settings/settings.component';
import UnsubscribeConfirmation from './pages/unsubscribe/unsubscribe_confirmation.component';
import RecommendedMeeting from './pages/recommended-meeting/RecommendedMeeting.component';
import Billing from './pages/billing/billing.component';

import CheckoutForm from './components/payment-integration/checkoutForm';
import Return from './components/payment-integration/return';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { strip_public_key, strip_test_public_key } from './env';
import CheckoutFormCardElement from './components/payment-integration/checkoutFormCardElement';
import PrivacyPolicy from './pages/privacy-policy/privacy-policy';
import RefundPolicy from './pages/refund-policy/refund-policy';
import { setPusherClient } from "react-pusher";
import Pusher from "pusher-js";
import clientConfig from "./env";
import "./App.css";
import CommunityGuidelines from './pages/community-guidelines/community-guidelines';
import AdminSettings from './pages/admin-settings/adminSettings.component';
import ApproveEvent from './pages/email-routes-events/approveEvent';
import DeclineEvent from './pages/email-routes-events/declineEvent';
import EventListing from './pages/events-listing/event-listing';

const stripePromise = loadStripe(strip_test_public_key);

function App() {
  const token = useSelector( state => state.user.token );

  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    const pusherClient = new Pusher(clientConfig?.pusherAppKey, {
      cluster: clientConfig?.pusherAppCluster,
    });

    setPusherClient(pusherClient);
  }, []);

  useEffect(() => {
    console.log("clientSecret:", clientSecret);
  }, [clientSecret]);

  const appearance = { theme: "stripe" }; // or 'flat', 'night', etc.
  const options = {
    clientSecret,
    appearance,
    locale: "en",
    defaultValues: {
      billingDetails: {
        address: {
          country: "US", // India
        },
      },
    },
  };

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          {token ? <Redirect to="/dashboard" /> : <LoginSignUp />}
        </Route>
        <Route path="/register">
          <Register />
        </Route>
        <Route path="/thankyou">
          <VerifyEmail />
        </Route>
        <Route path="/forgot-password">
          <ForgotPassword />
        </Route>
        <Route path="/dashboard">
          <Dashboard />
        </Route>
        <Route path="/my-profile">
          <MyProfile />
        </Route>
        <Route path="/p/:id" render={(props) => <MyConnection {...props} />} />
        <Route path="/schedule">
          <Schedule />
        </Route>
        <Route path="/schedule-settings">
          <Settings />
        </Route>
        <Route path="/connections">
          <Connections />
        </Route>
        <Route path="/my-connections">
          <MyConnections />
        </Route>
        <Route path="/pending-connections">
          <MyPendingConnections />
        </Route>
        <Route path="/faq">
          <FAQ />
        </Route>
        <Route path="/feedback">
          <Feedback />
        </Route>
        <Route path="/support">
          <Support />
        </Route>
        <Route path="/manage-preferences">
          <ManagePreferences />
        </Route>
        <Route path="/billing">
          <Billing />
        </Route>
        <Route path="/admin-settings">
          <AdminSettings />
        </Route>
        <Route path="/approve-event">
          <ApproveEvent />
        </Route>
        <Route path="/decline-event">
          <DeclineEvent />
        </Route>
        <Route path="/checkout">
          {clientSecret && (
            <Elements stripe={stripePromise} options={options}>
              <CheckoutFormCardElement />
            </Elements>
          )}
        </Route>
        <Route path="/return">
          <Return />
        </Route>
        <Route path="/change-password">
          <ChangePassword />
        </Route>
        <Route path="/call-schedule">
          <CallScheduled />
        </Route>
        <Route path="/connect">
          <AfterCallConnect />
        </Route>
        <Route path="/reschedule">
          <RescheduleCall />
        </Route>
        <Route path="/recommended-meeting">
          <RecommendedMeeting />
        </Route>
        <Route path="/unsubscribe">
          <Unsubscribe />
        </Route>
        <Route path="/unsubscribe-confirmation">
          <UnsubscribeConfirmation />
        </Route>
        <Route path="/terms-and-conditions">
          <TermsAndConditions />
        </Route>
        <Route path="/privacy-policy">
          <PrivacyPolicy />
        </Route>
        <Route path="/refund-policy">
          <RefundPolicy />
        </Route>
        <Route path="/events">
          <EventListing />
        </Route>
        <Route path="/community-guidelines">
          <CommunityGuidelines />
        </Route>
        <Route path="*">
          <NoMatch />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
